"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  create: function create(data) {
    return global.request.post('search-keys/create', data);
  },
  getList: function getList(data) {
    return global.request.post('search-keys', data, function (res) {
      return res;
    });
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGUiLCJkYXRhIiwiZ2xvYmFsIiwicmVxdWVzdCIsInBvc3QiLCJnZXRMaXN0IiwicmVzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvU2VhcmNoS2V5L1NlYXJjaEtleUFjdGlvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xyXG4gICAgY3JlYXRlOiAoZGF0YSkgPT4gZ2xvYmFsLnJlcXVlc3QucG9zdCgnc2VhcmNoLWtleXMvY3JlYXRlJywgZGF0YSksXHJcbiAgICBnZXRMaXN0OiAoZGF0YSkgPT4gZ2xvYmFsLnJlcXVlc3QucG9zdCgnc2VhcmNoLWtleXMnLCBkYXRhLCAocmVzKSA9PiB7XHJcbiAgICAgICAgcmV0dXJuIHJlcztcclxuICAgIH0pXHJcbn1cclxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7b0NBQWU7RUFDWEEsTUFBTSxFQUFFLFNBQVJBLE1BQU1BLENBQUdDLElBQUk7SUFBQSxPQUFLQyxNQUFNLENBQUNDLE9BQU8sQ0FBQ0MsSUFBSSxDQUFDLG9CQUFvQixFQUFFSCxJQUFJLENBQUM7RUFBQTtFQUNqRUksT0FBTyxFQUFFLFNBQVRBLE9BQU9BLENBQUdKLElBQUk7SUFBQSxPQUFLQyxNQUFNLENBQUNDLE9BQU8sQ0FBQ0MsSUFBSSxDQUFDLGFBQWEsRUFBRUgsSUFBSSxFQUFFLFVBQUNLLEdBQUcsRUFBSztNQUNqRSxPQUFPQSxHQUFHO0lBQ2QsQ0FBQyxDQUFDO0VBQUE7QUFDTixDQUFDIn0=